import * as React from 'react'
import Switch from '@mui/material/Switch'
import Typography from '@mui/material/Typography'

import { useTidalThemeActive, toggleTidalThemeActive } from './store'
import { isProduction } from '@sales-center/common'
import { useTheme } from '@mui/material/styles'

type TidalThemeSwitchProps = {
  contrastText?: boolean
}

export function TidalThemeSwitch(props: TidalThemeSwitchProps) {
  const { contrastText } = props
  const checked = useTidalThemeActive()
  const theme = useTheme()
  return (
    <Typography
      display={isProduction ? 'block' : 'none'}
      sx={{
        mx: 1,
        gap: 0.5,
        alignItems: 'center',
        color: contrastText
          ? theme.palette.primary.contrastText
          : theme.palette.text.primary,
      }}
      variant="body2"
    >
      SC
      <Switch checked={checked} onChange={toggleTidalThemeActive} />
      Tidal
    </Typography>
  )
}
